var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReverseTime = function SvgReverseTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ReverseTime_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.92 1.913-.81-.81a.572.572 0 0 0-.976.402v2.623a.57.57 0 0 0 .571.571h2.623c.51 0 .764-.617.405-.976l-.734-.734a4.574 4.574 0 1 1 .62 6.988.764.764 0 0 0-.875 1.25 6.097 6.097 0 1 0-.824-9.315Zm4.311 1.262a.57.57 0 0 0-.572.571v2.477c0 .153.06.298.167.405l1.715 1.715a.571.571 0 0 0 .807-.807L6.8 5.988V3.746a.57.57 0 0 0-.571-.571h.002Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ReverseTime_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.134 .126)",
    d: "M0 0h12.194v12.194H0z"
  })))));
};

export default SvgReverseTime;